import api from "../services/api";

/** Anuncios pendientes según servidor (pendingRead en GET /announcements) */
export function filterPendingAnnouncements(announcements) {
	if (!Array.isArray(announcements)) return [];
	return announcements.filter(
		(a) =>
			(a.status === true || a.status === 1) &&
			a.pendingRead === true
	);
}

export async function markAnnouncementReadRemote(announcementId) {
	const id = Number(announcementId);
	if (Number.isNaN(id)) return;
	await api.post(`/announcements/${id}/read`);
}

export async function bulkMarkAnnouncementsReadRemote(announcementIds) {
	const ids = [...new Set((announcementIds || []).map(Number).filter((n) => !Number.isNaN(n)))];
	if (!ids.length) return;
	await api.post("/announcements/bulk-read", { announcementIds: ids });
}
